// @/shared/components/CreditCardCallout/index.tsx
import React from "react";
import { BaseFeatureComponentProps } from "@/shared/components/FeatureSlot/registry";
import Strings from "@/shared/utils/Strings.constants";
import CreditCardsIcon from "@/shared/media/icons/cards.svg";

export interface CreditCardCalloutMetadata {
    superscript?: string;
}

export const CreditCardCallout: React.FC<BaseFeatureComponentProps<CreditCardCalloutMetadata>> = ({ metadata }) => {
    return (
        <div data-testid="call-out-banner" className="mt-5 flex rounded-lg bg-background-success p-2">
            <div className="flex flex-row items-center gap-2 sm:mx-auto">
                <CreditCardsIcon className="shrink-0 overflow-visible" />
                <span className="text-xs font-bold leading-4 text-content-primary">
                    {Strings.PTZ_US.SAMS_CC_CALLOUT}
                    {metadata?.superscript && <sup>{metadata.superscript}</sup>}
                </span>
            </div>
        </div>
    );
};
